(function () {
    'use strict';

    angular.module("imApp").factory("relatedPurchOrdersService", ['$ihttp', function ($ihttp) {
        let service = {
            listRelatedPurchaseOrders: function (parms) {
                return $ihttp.post({
                    method: 1140,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
